<template>
	<div v-if="!showFeedbackChild">
		<main class="main-wrapper flex-grow-1 with-footer" >

				<div class="d-flex align-items-center bg-white">
					<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
								{{$t('3107')}}
					</div>
					<div class="mgr-24 right-button">
						<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0"  type="button" @click="closeExamResult()">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-color-iconActive font-r">{{$t('3319')}}</span>
						</button>
					</div>
				</div>
				<div class="divider"></div>
					<question-navi-result
							v-if="solves.length"
							:currentQuestionId="currentQuestion.id ? currentQuestion.id :currentQuestion.questionId"
              :currentQuestionNumber="currentQuestion.number"
							:solves="solves"
							@selectQuestionNavi="selectQuestionNavi"
							></question-navi-result>
					<component :is="currentQuestion.type.value" v-if="currentQuestion"
							:key="currentQuestion.id ? currentQuestion.id : currentQuestion.number"
							ref="questionComp"
							:currentGroupIndex="currentGroupIndex"
							:feedback="feedback"
							:groupQuestionCount="currentGroupQuestionCount"
							:groupQuestionTitle="currentGroupQuestionTitle"
							:paperLevel="paperLevel"
							:question="currentQuestion"
			>
			</component>
		</main>
<div class="footer bg-white bottomStack">
<div class="divider"></div>
<div class="container container--narrow pdb-0">
<div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
	<div class="d-flex align-items-center">
			<button v-if="showBtnPrev()" class="mdc-button bg-secondary t-color-secondaryBtnText " tabindex="0" @click="previous()">
				<div class="mdc-button__ripple"></div>
				<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_left</i>
				<span class="mdc-button__label t-body2 font-r">{{$t('1245')}}</span>
			</button>
	</div>
	<div class="d-flex align-items-center">
			<button v-if="showBtnNext()"   class="mdc-button bg-secondary t-color-secondaryBtnText" tabindex="0" @click="next()">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('1246')}}</span>
				<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_right</i>
			</button>
			<button v-if="showBtnComplete()" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4" tabindex="0" @click="complete()">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('1265')}}</span>
			</button>
		</div>
	</div>
</div>
</div>

</div>
<transition v-else name="fade">
	<router-view></router-view>
</transition>
</template>


<script>
/**
 * 시험 피드백 메인 컴포넌트(exam feedback main component)
 *
 * @author minkyoung.park@emcast.com
 */

import {MDCRipple} from '@material/ripple'
import microExamApi from "@/api/microExamApi";
import QuestionNaviResult from './QuestionNaviResult'
import {microExamMixin} from "@/mixins/microExam";

const feedbackIssueArray = ['MicroExamFeedbackIssue', 'FinalMicroExamFeedbackIssue', 'MicroExamFeedbackQuestion', 'FinalMicroExamFeedbackQuestion'];

export default {
	data() {
		return {
			examTitle: '',
			paperLevel: '',

			paper: [],
			solves: [],
			questionSequence: '',
			questionGroup: null,
			feedback: null,

			currentQuestion: null,
			currentGroupIndex: 0,
			currentQuestionIndex: 0,
			currentGroupQuestionCount: 0,
			showFeedbackChild : false
		}
	},

	components: {
		'question-navi-result': QuestionNaviResult,
		'SHORT_ANSWER': () => import('./question/ShortAnswerFeedback.vue'),
		'CHOICE_SINGLE': () => import('./question/ChoiceSingleFeedback.vue'),
		'TRUE_OR_FALSE': () => import('./question/TrueandFalseFeedback.vue'),
		'CHOICE_MULTIPLE': () => import('./question/ChoiceMultipleFeedback.vue'),
		'FILL_IN_THE_RANGE': () => import('./question/FillInTheRangeFeedback.vue'),
		'FILL_IN_THE_BLANK': () => import('./question/FillInTheBlankFeedback.vue'),
		'ESSAY': () => import('./question/EssayFeedback.vue'),
	},

	mixins: [microExamMixin],

	mounted() {
		if(feedbackIssueArray.includes(this.$route.name)){
			this.showFeedbackChild = true;
		}
		this.setExamPaper()
		this.setMaterialUi()
	},

	beforeMount(){},

	methods: {
		// call api & set exam feedback data
		setExamPaper() {
			let responseData = null
			let params = {
				examineeId: this.$route.params.examineeId,
				paperId: this.$route.params.paperId
			}

			// call api exam result
			microExamApi.result(params).then((response) => {
				responseData = response.data.data

				this.examTitle = responseData.name
				this.paper = responseData.groups
				this.feedback = responseData.feedback
				this.paperLevel = responseData.level ? responseData.level.text : ''

				let number = 1
				_.each(this.paper, (group, groupIndex) => {
					_.each(group.questions, (question, questionIndex) => {
						question.groupIndex = groupIndex
						question.questionIndex = questionIndex
						question.number = number++
						question.groupId = group.id
					})
				})

				this.setCurrentQuestion()
				this.initAnswers()
			}).catch((err) => {

			})
		},

		// get question group
		getQuestionGroup() {
			this.questionGroup = this.paper[this.currentQuestionIndex]
		},

		// set current question
		setCurrentQuestion() {
			this.currentQuestion = this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex]
			this.currentGroupQuestionCount = this.paper[this.currentGroupIndex].questions.length
			this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name
		},

		isFirst() {
			return this.currentGroupIndex || this.currentQuestionIndex
		},

		isGroup() {
			return this.paper[this.currentGroupIndex].questions.length > 1
		},

    isLastGroupQuestion: function () {
      return this.paper[this.currentGroupIndex].questions.length === this.currentQuestionIndex + 1
    },

		isGroupLast(){
			return this.paper.length === this.currentGroupIndex + 1
		},

		isChecked() {
			return this.answers && this.currentQuestion ? this.answers[this.currentQuestion.id].checkStatus : false
		},


		showBtnNext() {
			return !this.isGroupLast() || !this.isLastGroupQuestion()
		},

		showBtnPrev() {
			return this.isFirst()
		},

		showBtnComplete() {
			return this.isGroupLast() && this.isLastGroupQuestion()
		},

		next() {
			this.currentQuestionCheckStatus = false

			if (this.isGroup()) {
				// is group question
				if (this.isLastGroupQuestion()) {
					// is group last question
					this.currentGroupIndex++
					this.currentQuestionIndex = 0
				}else {
					// is not group last question
					this.currentQuestionIndex++
				}
			} else {
				// is not group question
				this.currentGroupIndex++
				this.currentQuestionIndex = 0
			}
			this.setCurrentQuestion()
		},

		previous() {
			this.currentQuestionCheckStatus = false
			if (this.isGroup()) {
				// is group question
				if (!this.currentQuestionIndex) {
					// 그룹내 마지막 문항(is group last question)
					this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
					this.currentGroupIndex--
				}else {
					// 그룹내 이전 문항(is not group last question)
					this.currentQuestionIndex--
				}
			} else {
				// is not group question
				this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
				this.currentGroupIndex--
			}
			this.setCurrentQuestion()
		},

		// close Exam Result pop
		closeExamResult() {
			this.routerGoPrev()
		},

		complete() {
			this.routerGoPrev()
		},

		initAnswers() {
			let questionsData = _.chain(this.paper)
				.map(function (item) {
					return item.questions;
				})
				.flatten()
				.map(function (question, index) {
					return question
				}).value()

			_.each(questionsData, (question) => {
				this.solves.push({
					number: question.number,
					questionId: question.questionId,
					groupIndex: question.groupIndex,
					questionIndex: question.questionIndex,
					correct: question.correct
				})
		if(localStorage.getItem('Last_Route_tb') === question.questionId){
		//	this.myCurrentQuestionId = localStorage.getItem('Last_Route_tb');
		localStorage.removeItem('Last_Route_tb')
					this.selectQuestionNavi({
					number: question.number,
					questionId: question.questionId,
					groupIndex: question.groupIndex,
					questionIndex: question.questionIndex,
					correct: question.correct
				}, 0)}
			})
		},

		// select question navigation
		selectQuestionNavi(data, tabIndex) {
			this.currentGroupIndex = data.groupIndex
			this.currentQuestionIndex = data.questionIndex
			this.setCurrentQuestion()
		},

    routerGoPrev() {
      this.$router.push({
        name: "MicroDegreeView",
        params: this.$route.params.learnId,
        query: {status:this.$route.query.status},
      });
    },

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>
